'use client'; // 声明为客户端组件
import React, {ReactNode, useCallback, useEffect, useState} from 'react';
import {useParams, usePathname, useRouter} from 'next/navigation';
import RouterMgr from "@/Core/RouterMgr";
import Util from "@/Master/Util";
import AiHelpBox from "@/Core/AIHelp/AiHelpBox";
import GuideIOS from "@/app/_dialogs/GuideIOS";
import {Provider} from "react-redux";
import {store} from "@/app/store";
import {UserProvider} from "@/app/context/UserContext";
import WindowGlobal from "@/app/WindowGlobal";
import DBMgr from "@/Core/DBMgr";
import EventManager from "@/Fwk/EventManager";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {RewardDialogFC} from "@/app/_dialogs/RewardDialog/RewardDialog";
import GameMgr from "@/app/(game)/GameMgr";
import KitPwa, {PwaMsgType} from "@/Master/PWA/KitPwa";
import MainScene from "@/Core/MainScene";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {UpdateMainState} from "@/app/MainSliceUtil";
import usePageLifecycle from "@/app/hooks/usePageLifecycle";
import UtilUrl from "@/Core/UtilUrl";
import {Footer, Header} from "@/app/(pages)/components";

interface MainProps {
    children?: ReactNode;
}

export default function Main({children}: MainProps) {
    const router = useRouter();
    const pathname = usePathname();
    const [isShowGuideIOS, setIsShowGuideIOS] = useState(false)

    const isGamePage = pathname.includes('unity-game');

    //初始化请求类
    RequestMgr.Init();

    // 模拟 constructor：在首次渲染时调用SPlayer.checkInit()
    // 由于函数组件没有constructor，这里使用useEffect并在依赖数组中留空，
    useEffect(() => {
        WindowGlobal.Init();
        UtilUrl.Init();

        if (isGamePage) return;

        if (Util.isLog) {
            console.log('[Main] 初始化数据在这里');
        }

        RouterMgr.Init(router, pathname);


        MainScene.onInit();
        EventManager.addEventListener(PwaMsgType.onClaimInstalledReward, showInstalledReward)

        //初始化数据库
        DBMgr.Init(() => {
            UpdateMainState('UpdateIsDB', {isDBok: true});
        });

        EventManager.addEventListener(PwaMsgType.onIOS, startGuide);
        return () => {
            EventManager.removeEventListener(PwaMsgType.onClaimInstalledReward, showInstalledReward);
            EventManager.removeEventListener(PwaMsgType.onIOS, startGuide);
            if (Util.isLog) {
                console.log('[Main] 组件卸载前清理资源');
            }
            if (GameMgr.checkGamePath) {//是游戏页面内容 不进行登陆信息和初始化

            } else {
                MainScene.onDestroy();
            }
            // 在这里清理事件监听、计时器、socket等
        };
    }, []);

    if (isGamePage) {
        if (Util.isLog) {
            console.log('[Main] 这里是游戏页面');
        }
        return (
            <div className={`unity-game`}>
                {children}
            </div>
        )
    }

    usePageLifecycle();

    const showInstalledReward = (event: any)=>{
        if(Util.isLog){
            console.log('showInstalledReward===event',event)
        }
        if(KitPwa.isPlayPwa){
            SDialogManagerFC.openDialog(RewardDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RewardDialogFC),
                gcCount: event.detail.gcCount,
                scCount: event.detail.scCount,
            })
        }
    }

    const startGuide = () => {
        if (Util.isLog) {
            console.log('main', 'startGuide')
        }
        setIsShowGuideIOS(true)
    }

    const closeGuide = () => {
        if (Util.isLog) {
            console.log('main', 'closeGuide')
        }
        setIsShowGuideIOS(false)
    };

    return (
        <Provider store={store}>
            <UserProvider>
                <div className={`Main`}>
                    <Header/>
                    {children}
                    <Footer/>
                    <AiHelpBox/>
                    {/*{Util.isLog && Util.isTestMode && <TestBtnEnter/>}*/}
                    {/*{Util.isLog && Util.isTestMode && <TestBtnEnter/>}*/}
                    {isShowGuideIOS && <GuideIOS onCloseGuide={closeGuide}/>}
                </div>
            </UserProvider>
        </Provider>
    );
}


